import { Component, Injectable } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { SocialSecurityService } from '../../../services/previdencia/social-security.service';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';


@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
	readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        year: parseInt(date[0], 10),  // O ano vai ser o primeiro
        month: parseInt(date[1], 10), // O mês vai ser o segundo
        day: parseInt(date[2], 10),   // O dia vai ser o último
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date 
      ? date.year + this.DELIMITER + this.pad(date.month) + this.DELIMITER + this.pad(date.day) 
      : null;
  }

  private pad(n: number): string {
    return n < 10 ? '0' + n : '' + n;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '-';  // Para exibir com '-'

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date 
      ? this.pad(date.day) + this.DELIMITER + this.pad(date.month) + this.DELIMITER + date.year 
      : '';
  }

  private pad(n: number): string {
    return n < 10 ? '0' + n : '' + n;
  }
}

export function dateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    const regex = /^\d{4}-\d{2}-\d{2}$/;

    if (value && regex.test(value)) {
      return null; // A data está no formato correto
    }
    return { 'invalidDate': true }; 
  };
}

@Component({
  selector: 'app-solicitacao-boleto',
  templateUrl: './solicitacao-boleto.component.html',
  styleUrls: ['./solicitacao-boleto.component.css'],
  providers: [
		{ provide: NgbDateAdapter, useClass: CustomAdapter },
		{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter  },
	],
})
export class SolicitacaoBoletoComponent {
  dt: any = 2;
  dtm: any = 30;
  origemBoleto: any[] = [];
  tipoBoleto: any[] = [];
  loading: boolean = false;
  minDate: string;
  maxDate: string;
  maxValue: number = 1000000;
  ExisteBoletoPendente: boolean = false;
  ContratoAtivo: boolean = false;
  ExisteParcela: boolean = false;
  UltimaParcela: boolean = false;
  FechamentoMes: boolean = false;
  formGroup: FormGroup = new FormGroup({
    Dat_Prvpg_Blpgt: new FormControl(null, [dateValidator()]),
    Vlr_Prvst_Iblpgt: new FormControl(null, [Validators.required]),
    Origem: new FormControl(null),
    Tipo: new FormControl(0, [Validators.required]),
    TipoFatura: new FormControl("Emprestimo"),
  });

  feriado: any;
  constructor(private socialSecurityService: SocialSecurityService) {
    // Regra para validar se existe alguma parcela de prestação gerada
  this.socialSecurityService.listLoans({ itemsPerPage: 1, page: 1 }).subscribe((res: any) => {
    var parcelas = res?.items[0].parcel.filter((item: any) => { return item.type == 'Prestação' });
    if (parcelas.length > 0) { 
      this.ExisteParcela = true; 
    }
    if (res?.items[0].totalParcelRemainingCount == 1) { 
      this.UltimaParcela = true; 
    }
    if (res?.items[0] && res?.items[0]?.status == 'Ativo') { 
      this.ContratoAtivo = true; 
    }
    this.loading = false;
  });

  this.socialSecurityService.ValidaListaFeriado().subscribe((res: any) => {
    console.log(res)
    this.feriado = res
  })


  // Configura a data mínima como 2 dias a partir de hoje, dependendo do horário
  var today = new Date();
  var horario = today.getHours() >= 15 && today.getMinutes() >= 30 ? 2 : 1;
  this.minDate = this.formatDate(new Date(today.getTime() + horario * 24 * 60 * 60 * 1000)); // 2 dias a partir de hoje

  // Calculando o último dia útil do mês
  var lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0); // Último dia do mês

  let utilDay = 0;
  while (utilDay < 6) { // Depois do dia 31, voltamos para 3 dias úteis atrás
    if (lastDayOfMonth.getDay() != 6 && lastDayOfMonth.getDay() != 0) { // Se não for sábado (6) ou domingo (0)
      utilDay += 1;
    } else {
      lastDayOfMonth.setDate(lastDayOfMonth.getDate() - 1); // Decrementa 1 dia se for fim de semana
    }
  }

  // Subtraindo 3 dias úteis
  let daysToSubtract = 3;
  let count = 0;
  while (count < daysToSubtract) {
    lastDayOfMonth.setDate(lastDayOfMonth.getDate() - 1); // Decrementa 1 dia
    // Se não for fim de semana (sábado ou domingo)
    if (lastDayOfMonth.getDay() != 6 && lastDayOfMonth.getDay() != 0) {
      count += 1; // Contabiliza um dia útil
    }
  }

  // Calculando a data máxima
  this.maxDate = this.formatDate(lastDayOfMonth);

  // Verifica se a data máxima é menor que a data mínima
  if (this.maxDate < this.minDate) {
    this.FechamentoMes = true;
  }

  // Consulta o valor máximo de amortização para a data calculada
  this.socialSecurityService.GetMaxValueAmortizacao(this.formatDate(lastDayOfMonth)).subscribe((res: any) => {
    if (res == 0) {
      this.ExisteParcela = false;
    } else {
      this.maxValue = res.totalAPagar;
    }
  });

  // Obtém as origens de aporte
  socialSecurityService.getOrigensAporte().subscribe((res: any) => {
    this.origemBoleto = res.map((item: any) => ({
      nome: item.name,
      id: item.id
    }));
  });

  this.ValidaBoletoAtivo();

  // Configura o tipo de boleto padrão
  this.tipoBoleto.push({ nome: 'Amortização', id: 'M' });
  this.tipoBoleto.push({ nome: 'Antecipação', id: 'A' });
  this.formGroup.controls['Tipo'].setValue('M');
  }

  disableTyping(event: KeyboardEvent) {
    event.preventDefault();
  }
  openCalendar(event: FocusEvent) {
    const input = event.target as HTMLInputElement;
    input.showPicker();
  }
  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Meses começam do zero
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  };

  invalido: boolean = false;

  GenerateInvoice() {

    if (
      this.formGroup.controls['Dat_Prvpg_Blpgt']?.value == null ||  
      this.formGroup.controls['Origem']?.value == null||           
      this.formGroup.controls['Tipo']?.value == null||             
      this.formGroup.controls['Vlr_Prvst_Iblpgt']?.value == 0 || 
      this.formGroup.controls['Vlr_Prvst_Iblpgt']?.value == null
    ){      
      Swal.fire('Solicitação de Boleto', 'Favor preencher os campos obrigatórios', 'warning')
      this.invalido = true
      return;
    }
    if (this.formGroup.controls['Origem'].value == null) {
      this.formGroup.patchValue({
        Origem: 0
      });
    }
    if (new Date(this.formGroup.controls['Dat_Prvpg_Blpgt'].value).getDay() == 5 || new Date(this.formGroup.controls['Dat_Prvpg_Blpgt'].value).getDay() == 6) {
      Swal.fire('Solicitação de Boleto', 'Não é possivel solicitar o vencimento para o final de semana', 'warning')
      this.loading = false;
      return;
    }
    this.loading = true;
    this.socialSecurityService.PostGenerateInvoice(this.formGroup.value).subscribe((res: any) => {
      if (res) {
        Swal.fire('Solicitação de Boleto', 'Sua solicitação foi realizada com sucesso! O boleto estará disponível em até dois dias úteis.', 'success')
        this.loading = false;
      } else {
        Swal.fire('Solicitação de Boleto', 'Houve um erro ao solicitar o Boleto', 'error')
        this.loading = false;
      }
    })
    this.ValidaBoletoAtivo();
  }
  SetValuesAntecipacao() {
    const fieldValor = document.getElementById('valorBoleto');
    if (this.formGroup.controls['Tipo'].value == 'A') {
      this.formGroup.controls['Vlr_Prvst_Iblpgt'].setValue(this.maxValue);
      fieldValor?.setAttribute('disabled', 'disabled');
    } else {
      this.formGroup.controls['Vlr_Prvst_Iblpgt'].setValue(0);
      fieldValor?.removeAttribute('disabled');
    }
  }
  ValidateExistence() {
    console.log(this.formGroup.controls['Dat_Prvpg_Blpgt'].value)
    const button = document.getElementById('btnSubmit');
    if (this.formGroup.controls['Dat_Prvpg_Blpgt'].value != '') {
      this.socialSecurityService.ValidaBoletoAtivo().subscribe((res: any) => {
        if (res) {
          this.ExisteBoletoPendente = true;
          Swal.fire('Solicitação de Boleto', 'Já existe um boleto em aberto para este mês!', 'warning')
          button?.setAttribute('disabled', 'disabled');
        }
        else {
          button?.removeAttribute('disabled');
        }
      });
      this.socialSecurityService.ValidaFeriado(this.formGroup.controls['Dat_Prvpg_Blpgt'].value).subscribe((res: any) => {
        if (res) {
          Swal.fire('Solicitação de Boleto', 'Não é possivel solicitar boletos para feriado!', 'warning')
          button?.setAttribute('disabled', 'disabled');
        } else {
          button?.removeAttribute('disabled');
        }
      })
      this.socialSecurityService.GetMaxValueAmortizacao(this.formGroup.controls['Dat_Prvpg_Blpgt'].value).subscribe((res: any) => {
        this.maxValue = res.totalAPagar;
        this.ChangeMaxValue();
      })
    }
  }
  ValidaBoletoAtivo() {
    this.socialSecurityService.ValidaBoletoAtivo().subscribe((res: any) => {
      if (res) {
        this.ExisteBoletoPendente = true;
      }
    });
  }
  ChangeMaxValue() {
    if (this.formGroup.controls['Vlr_Prvst_Iblpgt'].value > this.maxValue || this.formGroup.controls['Tipo'].value == 'A') {
      this.formGroup.patchValue({
        Vlr_Prvst_Iblpgt: this.maxValue
      });
    }
  }

  model!: NgbDateStruct;
  
  isDisabled = (date: NgbDateStruct) => {
    const currentDate = new Date();
    const selectedDate = new Date(date.year, date.month - 1, date.day);

    // Verifica se a data está no próximo mês
    const nextMonth = new Date(currentDate);
    nextMonth.setMonth(currentDate.getMonth() + 1);
    const isNextMonth = selectedDate.getFullYear() === nextMonth.getFullYear() && selectedDate.getMonth() === nextMonth.getMonth();

    // Desabilita se a data for no passado
    const isPastDate = selectedDate < currentDate;

    // Verifica se é final de semana (sábado = 6, domingo = 0)
    const isWeekend = selectedDate.getDay() === 6 || selectedDate.getDay() === 0;

    // Verifica o último dia útil do mês
    const lastDayOfMonth = new Date(date.year, date.month, 0).getDate();

    // Calcula os últimos 3 dias úteis do mês
    let lastThreeWeekdays = [];
    let daysLeft = 3;
    for (let i = lastDayOfMonth; i >= 1 && daysLeft > 0; i--) {
        const checkDate = new Date(date.year, date.month - 1, i);
        if (checkDate.getDay() !== 6 && checkDate.getDay() !== 0) { // Se não for final de semana
            lastThreeWeekdays.push(i);
            daysLeft--;
        }
    }

    const isLastThreeDays = lastThreeWeekdays.includes(date.day);

    // Verifica se já passou das 15:30
    const currentHour = currentDate.getHours();
    const currentMinutes = currentDate.getMinutes();
    const after1530 = currentHour > 15 || (currentHour === 15 && currentMinutes > 30);

    // Calcula o próximo dia útil disponível
    const getNextBusinessDay = (daysToAdd: number) => {
        let nextDate = new Date(currentDate);
        while (daysToAdd > 0) {
            nextDate.setDate(nextDate.getDate() + 1);
            if (nextDate.getDay() !== 6 && nextDate.getDay() !== 0) { // Se for dia útil, reduz contador
                daysToAdd--;
            }
        }
        return nextDate;
    };

    const nextAvailableDate = getNextBusinessDay(after1530 ? 2 : 0);
    const isBeforeNextAvailableDate = selectedDate < nextAvailableDate;

    // Verifica se a data selecionada é um feriado
    const isHoliday = this.feriado.some((holiday: any) => {
        const holidayDate = new Date(holiday);
        return holidayDate.getFullYear() === selectedDate.getFullYear() &&
               holidayDate.getMonth() === selectedDate.getMonth() &&
               holidayDate.getDate() === selectedDate.getDate();
    });

    // Retorna true se a data for inválida (passada, final de semana, feriado, etc)
    return isPastDate || isWeekend || isLastThreeDays || isNextMonth || isBeforeNextAvailableDate || isHoliday;
};


  
  
}
